import { HomePage } from "src/app/home/home.page";

export interface PageInterface {
  title: string;
  name: string;
  component?: any;
  url?: string;
  color?: string;
  icon: string;
  requireLogIn: boolean;
  requireLogOut: boolean;
  logsOut?: boolean;
  number?: number | string | null;
  index?: number;
  tabName?: string;
  params?: any;
  isNew?: boolean;
  isBeta?: boolean;
  tabComponent?: any;
  requireRole?: string[];
}

export interface MenuInterface {
  header: string;
  items: PageInterface[];
}

export const MenuItems: MenuInterface[] = [
  {
    header: '', items: [
      { title: 'Dashboard', name: 'HomePage', color: 'primary', requireLogIn: true, requireLogOut: false, component: HomePage, url: '/home', icon: 'home' },
      // { title: 'Actions', name: 'ActionPage', requireLogIn: true, requireLogOut: false, url: '/actions', icon: 'checkmark-outline', requireRole: ['ROLE:ADMIN', 'ROLE:LIST', 'ROLE:CSUPPORT'] }
    ]
  },
  {
    header: 'Catalog', items: [
      { title: 'Product file export', name: 'FileExportPage', requireLogIn: true, requireLogOut: false, url: '/catalog/fileexport', icon: 'download-outline', requireRole: ['ROLE:ADMIN'] },
      { title: 'Reports', name: 'CoinReportsPage', requireLogIn: true, requireLogOut: false, url: '/catalog/coinreport', icon: 'document-text-outline', requireRole: ['ROLE:ADMIN'] },
      { title: 'Catalog', name: 'CoinlistPage', requireLogIn: true, requireLogOut: false, url: '/catalog/list', icon: 'file-tray-stacked-outline', requireRole: ['ROLE:ADMIN', 'ROLE:LIST'] },
      { title: 'Batch create', name: 'MultiplecreatePage', requireLogIn: true, requireLogOut: false, url: '/catalog/batchcreate', icon: 'duplicate-outline', requireRole: ['ROLE:ADMIN', 'ROLE:LIST'] },
      { title: 'Batch image upload', name: 'MultipleimagePage', requireLogIn: true, requireLogOut: false, url: '/catalog/batchimage', icon: 'images-outline', requireRole: ['ROLE:ADMIN', 'ROLE:LIST'] },

      { title: 'Categories', name: 'CategoryPage', requireLogIn: true, requireLogOut: false, url: '/catalog/category/list', icon: 'pricetags', requireRole: ['ROLE:PROGRAMMER'] },
      // { title: 'Ebay Importer', name: 'EbayimporterPage', requireLogIn: true, requireLogOut: false, url: '/catalog/import/ebay', icon: 'cloud-download-outline', requireRole: ['ROLE:PROGRAMMER'] }
    ]
  },
  {
    header: 'Handling & Shipping', items: [
      { title: 'Order Importer', name: 'OrderimporterPage', requireLogIn: true, requireLogOut: false, url: '/orders/import', icon: 'cloud-download-outline', requireRole: ['ROLE:ADMIN', 'ROLE:HANDSHIPPING', 'ROLE:CSUPPORT'] },
      { title: 'Handling', name: 'HandlingPage', requireLogIn: true, requireLogOut: false, url: '/orders/handling', icon: 'logo-buffer', requireRole: ['ROLE:ADMIN', 'ROLE:HANDSHIPPING'] },
      { title: 'Shipping', name: 'ShippingPage', requireLogIn: true, requireLogOut: false, url: '/orders/shipping', icon: 'cube-outline', requireRole: ['ROLE:ADMIN', 'ROLE:HANDSHIPPING'] },
      { title: 'Older orders', name: 'OlderOrdersPage', requireLogIn: true, requireLogOut: false, url: '/orders/list', icon: 'file-tray-full-outline', requireRole: ['ROLE:ADMIN', 'ROLE:HANDSHIPPING'] }
    ]
  },
  {
    header: 'Billing', items: [
      { title: 'Invoices', name: 'InvoicelistPage', requireLogIn: true, requireLogOut: false, url: '/billing/invoice/list', icon: 'calculator', requireRole: ['ROLE:ADMIN', 'ROLE:HANDSHIPPING', 'ROLE:FINANCES'] },
      { title: 'Accounting summary', name: 'AccountingsummaryPage', requireLogIn: true, requireLogOut: false, url: '/billing/accountingsummary', icon: 'analytics', requireRole: ['ROLE:ADMIN', 'ROLE:HANDSHIPPING', 'ROLE:FINANCES'] },
    ]
  },
  {
    header: 'CRM', items: [
      { title: 'Client Register', name: 'ClientregisterPage', requireLogIn: true, requireLogOut: false, url: '/crm/client/new', icon: 'person-add-outline', requireRole: ['ROLE:ADMIN', 'ROLE:CSUPPORT'] },
      // { title: 'Client CRM', name: 'SearchclientPage', requireLogIn: true, requireLogOut: false, url: '/crm/client/find', icon: 'people-outline', requireRole: ['ROLE:ADMIN', 'ROLE:CSUPPORT'] },
      // // { title: 'Incidences', name: 'IncidencesPage', requireLogIn: true, requireLogOut: false, url: '/crm/incidences', icon: 'alert', requireRole: ['ROLE:ADMIN', 'ROLE:CSUPPORT'] },
      // { title: 'Tickets', name: 'TicketsPage', requireLogIn: true, requireLogOut: false, url: '/crm/tickets', icon: 'help-circle-outline', requireRole: ['ROLE:ADMIN', 'ROLE:CSUPPORT'] }
    ]
  },
  {
    header:'CMS',items:[
      { title: 'Post elements', isNew:true, name: 'CmslistPage', requireLogIn: true, requireLogOut: false, url: '/cms/list', icon: 'people-outline', requireRole: ['ROLE:ADMIN', 'ROLE:CSUPPORT'] },
      { title: 'Create post', isNew:true, name: 'CmseditPage', requireLogIn: true, requireLogOut: false, url: '/cms/new/edit', icon: 'add-outline', requireRole: ['ROLE:ADMIN', 'ROLE:CSUPPORT'] },
    ]
  },
];

export const UserMenuItems: MenuInterface[] = [{
  header: "Other", items: [
    { title: 'Log Out', name: 'LoginPage', requireLogIn: true, requireLogOut: false, url: '/login', icon: 'log-out', logsOut: true, params: {noautologin: true} },
    { title: 'Log In', name: 'LoginPage', requireLogIn: false, requireLogOut: true, url: '/login', icon: 'log-in' },
    { title: 'Settings', name: 'SettingsPage', requireLogIn: false, requireLogOut: false, url: '/settings', icon: 'settings' },
    { title: 'Info', name: 'AboutPage', requireLogIn: false, requireLogOut: false, url: '/about', icon: 'information-circle' }
  ]
}
];
